<div class="legend-table">
  <div style="display: inline-block" *ngFor="let inspectionPointType of inspectionPointTypes">
    <div class="legend-table-cell legend-label">
      {{inspectionPointType.name}}:
    </div>
    <div class="legend-table-cell legend-color">
      <div class="legend-square" [style.background-color]="inspectionPointType.color"></div>
    </div>
  </div>
</div>